<template>
  <div class="flex mx-auto bb-jcc bb-aic
  bb-xl-jcl" >
    <div class="bb-pointer inline-block bb-xl-mln2pt5"
    :class="{ 'bb-op0': sliderStart}"
    @click="slidePrev">
      <i class="material-icons bb-fs2pt17 bb-fc1 bb-usnone">&#xE5CB;</i>
    </div>
    <div class="inline-block bb-w15 bb-mid-w30">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="movie in swiperData" :key="movie.value._id"
        class="center">
          <img :src="getImageUrl(movie.doc.uri, imageName)"
          class="bb-h13pt5">
        </swiper-slide>
      </swiper>
    </div>
    <div @click="slideNext"
    class="bb-pointer inline-block"
    :class="{ 'bb-op0pt3': sliderEnd}">
      <i class="material-icons bb-fs2pt17 bb-fc1 bb-usnone">&#xE5CC;</i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'carrousel',
  props: ['swiperData'],
  data () {
    let self = this
    return {
      sliderStart: true,
      sliderEnd: false,
      imageName: '/501-poster.jpg',
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 0,
        simulateTouch: false,
        onReachBeginning: function (swiper) {
          self.sliderStart = true
        },
        onReachEnd: function (swiper) {
          self.sliderEnd = true
        },
        breakpoints: {
          736: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  watch: {
    'swiperData': function () {
      this.sliderStart = true,
      this.sliderEnd = false
    }
  },
  methods: {
    getImageUrl: function (uri, name) {
      return this.$store.getters.getImageUrl(uri, name)
    },
    slidePrev: function () {
      this.swiper.slidePrev(true, 500)
      if (!this.sliderStart) {
        this.sliderEnd = false
      }
    },
    slideNext: function () {
      this.swiper.slideNext(true, 500)
      if (!this.sliderEnd) {
        this.sliderStart = false
      }
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/swiper.vue